// src/services/api.js
import axios from "axios";

const normalizeApiBaseUrl = (url) => String(url || "").replace(/\/+$/, "");

const getConfiguredApiBaseUrl = () => {
  const configuredUrl = process.env.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

  if (configuredUrl) {
    return normalizeApiBaseUrl(configuredUrl);
  }

  throw new Error("Missing API base URL. Start the app with npm start or npm run start:production.");
};

const API_BASE_URL = getConfiguredApiBaseUrl();

// Create a pre-configured axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add a request interceptor if you want to add authorization tokens later
api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default api;
